import { connect } from "react-redux";
import RecoverPasswordForm from "../components/RecoverPasswordForm";
import {
  disableUserLoader,
  saveRecoverPasswordForm,
} from "../../modules/user/actions";

export default connect(
  (state) => ({
    isUserLoading: state.user.isLoading,
  }),
  (dispatch) => ({
    saveRecoverPasswordForm: (values) => {
      dispatch(saveRecoverPasswordForm(values));
    },
    disableUserLoader: (values) => {
      dispatch(disableUserLoader(values));
    },
  }),
)(RecoverPasswordForm);
